/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Tab_TrackInputs */

const en_event_group_options_tab_track = /** @type {(inputs: Event_Group_Options_Tab_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track Operations`)
};

const fr_event_group_options_tab_track = /** @type {(inputs: Event_Group_Options_Tab_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opérations de piste`)
};

const de_event_group_options_tab_track = /** @type {(inputs: Event_Group_Options_Tab_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gleisbetrieb`)
};

const it_event_group_options_tab_track = /** @type {(inputs: Event_Group_Options_Tab_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operazioni di tracciamento`)
};

const ru_event_group_options_tab_track = /** @type {(inputs: Event_Group_Options_Tab_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эксплуатация путей`)
};

const es_event_group_options_tab_track = /** @type {(inputs: Event_Group_Options_Tab_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operaciones de pista`)
};

const zh_cn2_event_group_options_tab_track = /** @type {(inputs: Event_Group_Options_Tab_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`轨道运营`)
};

const ja_event_group_options_tab_track = /** @type {(inputs: Event_Group_Options_Tab_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トラックオペレーション`)
};

const hi_event_group_options_tab_track = /** @type {(inputs: Event_Group_Options_Tab_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ट्रैक संचालन`)
};

const pt_pt2_event_group_options_tab_track = /** @type {(inputs: Event_Group_Options_Tab_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operações de rastreamento`)
};

/**
* | output |
* | --- |
* | "Track Operations" |
*
* @param {Event_Group_Options_Tab_TrackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_tab_track = /** @type {((inputs?: Event_Group_Options_Tab_TrackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Tab_TrackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_options_tab_track(inputs)
	if (locale === "de") return de_event_group_options_tab_track(inputs)
	if (locale === "it") return it_event_group_options_tab_track(inputs)
	if (locale === "ru") return ru_event_group_options_tab_track(inputs)
	if (locale === "es") return es_event_group_options_tab_track(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_options_tab_track(inputs)
	if (locale === "ja") return ja_event_group_options_tab_track(inputs)
	if (locale === "hi") return hi_event_group_options_tab_track(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_options_tab_track(inputs)
	return en_event_group_options_tab_track(inputs)
});